import { Box, Heading, Text, VStack } from "@chakra-ui/react"

const Explore: React.FC = () => {
  return (
    <Box p={8}>
      <VStack gap={6} align="stretch">
        <Heading size="xl">Explore</Heading>
        <Text color="gray.600" fontSize="lg">
          Coming soon
        </Text>
      </VStack>
    </Box>
  )
}

export default Explore
